const state = {
    compareList: {}
};

const getters = {
    getCompareList:     (state) => state.compareList
};

const actions = {
    async addCompareItem({ commit, state }, it) {
        var item = it
        if(item.type == 'graphics'){
            item.type = 'gpu'
        }
        if (state.compareList[item.type] && state.compareList[item.type].length !==0){
            if (state.compareList[item.type].includes(item)){
               console.log('already in the list')
            }else { commit('newCompareItem', item); 
            }
        }else {
            commit('newCompareItem', item);
        }
    },
    async removeFromCompare({ commit, state }, it){
        console.log('removing from compare list')
        var item = it
        var compare_list = {...state.compareList}
        if(item.type == 'graphics'){
            item.type = 'gpu'
        }
        if(compare_list[item.type]){
            compare_list[item.type].map((itm) => {
                if(itm.id == item.id){
                    commit('removedFromCompare', it)
                }
              })
            console.log(item.type+ ' removed from compare list')
        }
    }
}

const mutations = {
    newCompareItem(state, item) {
        var compare_list = state.compareList
        var compare_item = item
        if(compare_item.type == 'graphics'){
            compare_item.type = 'gpu'
        }
        if(!compare_list[item.type]){
            compare_list[item.type] = []
        }
        compare_list[item.type].push(item)
        compare_list[item.type].sort((a, b) => (a.performance > b.performance) ? 1:-1)
        state.compareList = {...compare_list}
    },
    removedFromCompare(state, item) {
        var compare_list = state.compareList
        if(compare_list[item.type]){
            if(compare_list[item.type].type == 'graphics'){
                compare_list[item.type].type = 'gpu'
            }
            compare_list[item.type].splice(compare_list[item.type].indexOf(item), 1)
        }
        if(compare_list[item.type] && compare_list[item.type].length < 1){
            delete compare_list[item.type]
        }
        state.compareList = {...compare_list}
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}